import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { compose } from 'recompose';
import _map from 'lodash/map';
import _range from 'lodash/range';
import _startCase from 'lodash/startCase';
import _property from 'lodash/property';
import _set from 'lodash/set';
import _castArray from 'lodash/castArray';
import _pick from 'lodash/pick';
import _get from 'lodash/get';
import _reduce from 'lodash/reduce';
import _find from 'lodash/find';
import _filter from 'lodash/filter';
import _orderBy from 'lodash/orderBy';
import { URL_TYPES } from '../../constants/api';
import { DEAL_STATUS_DISPLAY_MAP } from '../../constants/deal/status';
import { NO_DATA } from '../../app.constants';
import { YES, NO } from '../../constants/deal/common';
import { DEAL_STATUS_VS_CONDITION_TO_SHOW } from '../../marketScan/utils/desking.utils';

var getResponse = _property('data.data');

var getTdpResponse = _property('data');

var getErrorDetails = _property('data.errorDetails');

var statusCode = _property('status');

export var getYearOptions = function getYearOptions() {
  var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1920;
  var end = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date().getFullYear() + 3;
  return _orderBy(_map(_range(start, end), function (year) {
    return {
      label: year,
      value: year
    };
  }), 'value', ['desc']);
};
export var getSelectOptions = function getSelectOptions(options) {
  var hasFormatters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var formatters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [_startCase];
  return _map(options, function (opt) {
    var label = !hasFormatters ? opt : compose.apply(void 0, _toConsumableArray(formatters))(opt);
    return {
      label: label,
      value: opt
    };
  });
};
export var getOptionsByMap = function getOptionsByMap(data) {
  var valueKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'value';
  return _map(data, function (value, key) {
    return _defineProperty({
      label: value
    }, valueKey, key);
  });
};
export var interceptResponse = function interceptResponse(urlType) {
  return function (rawResponse) {
    var status = statusCode(rawResponse);

    if (status >= 200 && status <= 299) {
      return {
        response: urlType === URL_TYPES.TDP ? getTdpResponse(rawResponse) : getResponse(rawResponse),
        rawResponse: rawResponse
      };
    }

    return {
      error: {
        errorCode: statusCode(rawResponse),
        detail: getErrorDetails(rawResponse),
        rawResponse: rawResponse
      }
    };
  };
};
export var getVehiclePayload = function getVehiclePayload(vehicle) {
  var vehiclePayload = {};
  vehiclePayload = _pick(vehicle, ['id', 'vin', 'status', 'leadId', 'vehicleType', 'stockID']);
  vehiclePayload.glAccountNumber = _get(vehicle, 'accountNumber');
  vehiclePayload.viOptions = _get(vehicle, 'options');
  vehiclePayload.primaryVehicle = true;
  return vehiclePayload;
};
export var getPaylodForDealCreate = function getPaylodForDealCreate(data) {
  var paymentOption = data.paymentOption,
      vehicle = data.vehicle;
  var payload = {};

  _set(payload, 'type', 'PERSONAL');

  _set(payload, 'status', 'QUOTE');

  _set(payload, 'penEnabled', true);

  _set(payload, 'paymentTemplate.paymentOptions', _castArray(paymentOption));

  _set(payload, 'customers', _castArray({
    type: 'BUYER'
  }));

  _set(payload, 'vehicles', _castArray(getVehiclePayload(vehicle)));

  return payload;
};
export var getDealTypesOptions = function getDealTypesOptions(dealTypesFromSetup) {
  return _reduce(dealTypesFromSetup, function (acc, _ref2) {
    var enabled = _ref2.enabled,
        dealType = _ref2.dealType,
        displayName = _ref2.displayName;

    if (enabled) {
      acc.push({
        value: dealType,
        label: displayName
      });
    }

    return acc;
  }, []);
};
export var getDealTypeDisplayValue = function getDealTypeDisplayValue(value, dealTypesFromSetup) {
  return _get(_find(dealTypesFromSetup, function (_ref3) {
    var dealType = _ref3.dealType;
    return dealType === value;
  }), 'displayName');
};
export var parseResponse = _property('response');
export var handleResponse = function handleResponse(response) {
  return parseResponse(interceptResponse()(response));
};
export var getStatusFilterOptions = function getStatusFilterOptions(statuses) {
  return _map(statuses, function (status) {
    return {
      label: DEAL_STATUS_DISPLAY_MAP[status],
      value: status
    };
  });
};
export var getFilteredDealStatuses = function getFilteredDealStatuses(statuses, salesSetupInfo) {
  return _filter(statuses, function (status) {
    return DEAL_STATUS_VS_CONDITION_TO_SHOW(salesSetupInfo)[status];
  });
};
var DASH = '-';
export var startCaseWithDash = function startCaseWithDash(str) {
  var value = _startCase(str);

  if (str !== null && str !== void 0 && str.includes(DASH)) {
    value = str.split(DASH).map(function (subStr) {
      return _startCase(subStr);
    }).join(DASH);
  }

  return value;
};
export var getTaxCodeFilterOptions = function getTaxCodeFilterOptions(taxCodes) {
  return _map(taxCodes, function (taxCodeObj) {
    return {
      label: taxCodeObj.taxCode,
      value: taxCodeObj.id
    };
  });
};

var fillBlank = function fillBlank(value) {
  return value || NO_DATA;
};

export var mapBoolToYesOrNo = function mapBoolToYesOrNo(value) {
  try {
    if (JSON.parse(value)) return YES;
    return NO;
  } catch (error) {
    return fillBlank();
  }
};